const vimeoIframe = document.querySelector('.banner-video-container iframe');
const closeButtonPopupBanner = document.querySelector('[data-close-button]');
const modalContent = document.querySelector('[data-modal-content]');
if (vimeoIframe && closeButtonPopupBanner) {
  const vimeoPlayer = new Vimeo.Player(vimeoIframe);
  closeButtonPopupBanner.addEventListener('click', function () {
    vimeoPlayer.pause().catch(function (error) {
      console.error("Erreur lors de la mise en pause :", error);
    });
  });
  document.addEventListener('click', function (event) {
    if (!modalContent.contains(event.target) && !closeButtonPopupBanner.contains(event.target)) {
      vimeoPlayer.pause().catch(function (error) {
        console.error("Erreur lors de la mise en pause :", error);
      });
    }
  });
}